import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoTextEditModalComponent } from './info-text-edit-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexModule } from '@angular/flex-layout';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  declarations: [InfoTextEditModalComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    FlexModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
  ],
})
export class InfoTextEditModalModule {}
